<template>
    <div class="min-h-screen"  v-loading="loading">
        <h1 class="title">{{day}} 空气质量排名</h1>

        <!-- 表格 -->
        <div class="bg-white p-4 rounded-2xl shadow">
            <el-table
                    size="mini"
                    :data="tableData"
                    @sort-change="sortChange"
                    style="width: 100%">
                <el-table-column
                        prop="cityName"
                        align="center"
                        label="城市">
                </el-table-column>
                <el-table-column label="PM2.5浓度 (ug/m3)" align="center">
                    <el-table-column
                            prop="pm25Daily"
                            label="日均"
                            sortable="custom"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="pm25Monthly"
                            label="月均"
                            sortable="custom"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="pm25Yearly"
                            label="年均"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="pm25MonthChange"
                            label="月同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.pm25MonthChange > 0 ? 'red' : 'black' }">
                                 {{scope.row.pm25MonthChange }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="pm25YearChange"
                            label="年同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.pm25YearChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.pm25YearChange }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="PM10浓度  (ug/m3)"  align="center">
                    <el-table-column
                            prop="pm10Daily"
                            label="日均"
                            sortable="custom"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="pm10Monthly"
                            label="月均"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="pm10Yearly"
                            label="年均"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="pm10MonthChange"
                            label="月同比变化（%）"
                            sortable="custom"
                            >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.pm10MonthChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.pm10MonthChange }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="pm10YearChange"
                            label="年同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.pm10YearChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.pm10YearChange }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="NO2浓度 (ug/m3)"  align="center">
                    <el-table-column
                            prop="no2Daily"
                            label="日均"
                            sortable="custom"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="no2Monthly"
                            label="月均"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="no2Yearly"
                            label="年均"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="no2MonthChange"
                            label="月同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.no2MonthChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.no2MonthChange }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="no2YearChange"
                            label="年同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.no2YearChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.no2YearChange }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="O3浓度  (ug/m3)"  align="center">
                    <el-table-column
                            prop="o3Daily"
                            label="日均"
                            sortable="custom"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="o3Monthly"
                            label="月均"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="o3Yearly"
                            label="年均"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="o3MonthChange"
                            label="月同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.o3MonthChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.o3MonthChange }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="o3YearChange"
                            label="年同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.o3YearChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.o3YearChange }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="优良天数比率"  align="center">
                    <el-table-column
                            prop="monthGoodDaysRatio"
                            label="月优良率（%）"
                            sortable="custom"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="yearGoodDaysRatio"
                            label="年优良率（%）"
                            sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="monthGoodDaysRatioChange"
                            label="月同比变化 （%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.monthGoodDaysRatioChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.monthGoodDaysRatioChange }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goodYearChange"
                            label="年同比变化（%）"
                            sortable="custom"
                    >
                        <template slot-scope="scope">
                            <span :style="{ color: scope.row.yearGoodDaysRatioChange > 0 ? 'red' : 'black' }">
                                  {{scope.row.yearGoodDaysRatioChange }}
                            </span>
                        </template>
                    </el-table-column>

                </el-table-column>
            </el-table>
        </div>


        <!-- 柱状图 -->
        <div class="chartBar">
            <echarts :charts-option="chartsOption"></echarts>
        </div>

    </div>
</template>

<script>

    import Echarts from "../components/echart/echarts";
    import UrlApi from "@/utils/UrlApi.js";
    export default {
        name: 'AirQualityRanking',
        components: {Echarts},
        data() {
            return {
                tableData: [],
                day:"",
                loading:false,
                chartsOption:{},

                Dform:{
                    prop:"",
                    order:"",
                }


            };
        },
        computed: {
        },
        mounted(){
          // this.initEchart()
          this.getData()
        },
        methods:{

            sortChange( column, prop, order ){
                console.log(column)
                if(column.order==='ascending'){
                    this.Dform.order ='asc'
                }else if (column.order==='descending'){
                    this.Dform.order='desc'
                }
                this.Dform.prop = column.prop
                this.getData()
            },

            getData(){
                this.loading = true
                this.$http.get(UrlApi.airRank, {
                    params: this.Dform
                }).then(res => {
                    // console.log(res)
                    this.loading= false
                   this.tableData = res.data.data.rankingList
                   this.day = res.data.data.day

                    this.initEchart()


                })
            },

            initEchart() {


                let list = this.tableData

                let yAxisLabel = []
                let serveData = [
                    {
                        realtimeSort: true,
                        name: 'PM2.5浓度',
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'right'
                        },
                        data: []
                    },
                    {
                        realtimeSort: true,
                        name: 'PM10浓度',
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'right'
                        },
                        data: []
                    },
                    {
                        realtimeSort: true,
                        name: 'NO2浓度',
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'right'
                        },
                        data: []
                    },
                    {
                        realtimeSort: true,
                        name: 'O3浓度',
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'right'
                        },
                        data: []
                    },
                    {
                        realtimeSort: true,
                        name: '优良天数比率',
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'right'
                        },
                        data: []
                    }
                ]

                list.forEach((item)=>{
                    yAxisLabel.push(item.cityName)
                    serveData[0].data.push(item.pm25Daily)
                    serveData[1].data.push(item.pm10Daily)
                    serveData[2].data.push(item.no2Daily)
                    serveData[3].data.push(item.o3Daily)
                    serveData[4].data.push(item.monthGoodDaysRatio)
                })



                let option  = {
                    title: {
                        text: this.day+'空气质量'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        data: yAxisLabel
                    },
                    series: serveData
                };
                this.chartsOption = option
            },
        }
    };
</script>

<style scoped lang="less">
    .chartBar{
        height: 800px;
    }
    .min-h-screen{
        .title{
            text-align: center;
            padding: 20px;
        }
    }
</style>

